import { GetWorkerAuditMonitoringListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatWorkerAuditMonitoringDetail = (
	input: GetWorkerAuditMonitoringListResponse['content'][number],
	index: number,
	params: {
		total: number;
		page: number;
		pageSize: number;
	}
) => {
	return {
		...input,
		no: params.total - (params.page - 1) * params.pageSize - index,
		registDt: formatDate(input.registDt, {
			outputFormat: 'YYYY-MM-DD HH:mm:ss',
		}),
	};
};

export const formatWorkerAuditMonitoringList = (
	input: GetWorkerAuditMonitoringListResponse['content'],
	params: {
		total: number;
		page: number;
		pageSize: number;
	}
) => {
	return map(input, (value, index) =>
		formatWorkerAuditMonitoringDetail(value, index, params)
	);
};
